import React from 'react'

import CSS from './LandingPage.module.css';

function Section2() {
    return (
        <div className={`${CSS.section2} `}>
            <div className={CSS.content2}>
            <h2 >Connect to the network nearby your unit.</h2>
            <ul>
                <li>Connect to all the sellers in the market</li>
                <li >Experience the change in service</li>
                <li >Remove the constraint of limited resources,inaccessiblity to marktet and variety on service</li>
            </ul>
            </div>
            <div className={CSS.image2}></div>
        </div>  
    )
}

export default Section2
